'use client';

import { useState } from 'react';

import type { HumanReviewRequestFilter } from '@/lib/admin/client';
import {
  humanReviewDisabled,
  humanReviewFacets,
  useHumanReviewRequests,
} from '@/lib/query/useHumanReviewRequests';

import { HumanReviewOverview } from './HumanReviewOverview';
import { HumanReviewRequestsPanel } from './HumanReviewRequestsPanel';

const INITIAL_FILTER: HumanReviewRequestFilter = {
  state: 'pending',
  subjectType: null,
  priority: null,
  decisionSource: null,
  sort: 'oldest',
};

const OVERVIEW_FILTER: HumanReviewRequestFilter = {
  state: 'all',
  subjectType: null,
  priority: null,
  decisionSource: null,
  sort: 'newest',
};

export function HumanReviewTab() {
  const [filter, setFilter] =
    useState<HumanReviewRequestFilter>(INITIAL_FILTER);
  const overview = useHumanReviewRequests(OVERVIEW_FILTER);
  const pendingOverview = useHumanReviewRequests(INITIAL_FILTER);
  const facets = humanReviewFacets(overview.data);
  const pendingFacets = humanReviewFacets(pendingOverview.data);

  return (
    <div className="space-y-6">
      <HumanReviewOverview
        facets={facets}
        pendingFacets={pendingFacets}
        isLoading={overview.isLoading || pendingOverview.isLoading}
        isError={overview.isError || pendingOverview.isError}
        isDisabled={
          humanReviewDisabled(overview.data) ||
          humanReviewDisabled(pendingOverview.data)
        }
        onFilterChange={setFilter}
      />
      <HumanReviewRequestsPanel filter={filter} onFilterChange={setFilter} />
    </div>
  );
}
